module.exports = __webpack_public_path__ + "fonts/Manrope-500-latin-ext11.4e3c84a.woff2";